import { render, staticRenderFns } from "./CreatePhoneBooking.vue?vue&type=template&id=b07cf3e6&scoped=true"
import script from "./CreatePhoneBooking.vue?vue&type=script&lang=js"
export * from "./CreatePhoneBooking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b07cf3e6",
  null
  
)

export default component.exports